import React from 'react';

const AdminFooter = () => {
    return (
        <div class="copy text-center pt-2">
            © Copyright 2024 <b>Fixkart Interio</b> | All Rights Reserved.
        </div>
    );
};

export default AdminFooter;
